/**
 * 配置文件
 */
const useIDM = process.env.VUE_APP_USE_IDM_SSO === 'true';
import { version } from '../../package.json';

const configObj = {
  // 区分环境配置
  baseURL: process.env.VUE_APP_BASE_URL,
  dbaseURL: process.env.VUE_APP_UBASE_URL,
  originURL: process.env.VUE_APP_ORIGIN_URL,
  newSsoLoginUrl: useIDM ? process.env.VUE_APP_IDM_SSO_PAGE_URL : process.env.VUE_APP_SSO_PAGE_URL,
  useIDM,
  ossBucket: process.env.VUE_APP_OSS_BUCKET,
  ssoClientId: useIDM ? process.env.VUE_APP_LIUHE_CLIENT_ID : process.env.VUE_APP_CLIENT_ID,
  // 用户中心退出登录页面
  newUserCenterLogoutUrl: useIDM ? process.env.VUE_APP_IDM_SSO_LOGOUT_PAGE_URL :process.env.VUE_APP_SSO_LOGOUT_PAGE_URL,
  // 公共配置
  appCode: 'ADMIN',
  defaultAuthorization: 'Basic dXBtczp1cG1z', // 实际就是Base64.encode('upms:upms')
  isDevelop:
    process.env.VUE_APP_ENV_NAME === 'development' ||
    process.env.VUE_APP_ENV_NAME === 'fat',
  loginType: 'local', // 用户信息存储本地
  // 公共页面配置
  paginationSize: 20, // 页面表格每页显示条数
  paginationPages: [10, 20, 30, 40, 60, 80, 100],
  version
};

export default configObj;
